import React, { FC } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { YaraMatchesGridProps } from "../../@types";
import { ClassificationIcon, RenderWhen } from "../../../../../../components";
import Typography from "../../../../../../components/typography/Typography";
import styles from "./yara-matches.module.scss";
import { PAGE_PATH } from "../../../../../../path";
import TooltipWrapper from "../../../../../../enhancers/TooltipWrapper";

type Props = {
  yaraMatch: YaraMatchesGridProps;
};

const YaraMatchesRuleset: FC<Props> = ({ yaraMatch }) => (
  <TooltipWrapper
    condition={!yaraMatch.matchedRulesetId}
    wrapper={(children: JSX.Element) => (
      <OverlayTrigger
        overlay={<Tooltip>Ruleset was deleted from the system.</Tooltip>}
        placement="top"
      >
        <span>{children}</span>
      </OverlayTrigger>
    )}
  >
    <RenderWhen condition={!!yaraMatch.matchedRulesetClassification}>
      <ClassificationIcon
        classification={yaraMatch.matchedRulesetClassification}
        classificationStyle={{
          flexShrink: 0
        }}
      />
    </RenderWhen>
    <Typography
      variant={"body1"}
      className={`${styles.item_link} overflow-ellipsis width-100-pc`}
    >
      {yaraMatch.matchedRulesetName}
    </Typography>
  </TooltipWrapper>
);

const YaraMatchesMatchedRuleset: FC<Props> = ({ yaraMatch }) => {
  if (!yaraMatch.matchedRulesetId) {
    return <YaraMatchesRuleset yaraMatch={yaraMatch} />;
  }

  const yaraMatchedRulesetLink = `${
    PAGE_PATH.YARA
  }${PAGE_PATH.YARA_DETAILS.replace(
    ":rulesetId",
    yaraMatch.matchedRulesetId.toString()
  )}`;

  return (
    <Link
      to={yaraMatchedRulesetLink}
      className={styles.grid_element_with_classification}
      data-testid="summary_report_yara_grid_matched_ruleset_link"
    >
      <YaraMatchesRuleset yaraMatch={yaraMatch} />
    </Link>
  );
};

export default YaraMatchesMatchedRuleset;
